// extracted by mini-css-extract-plugin
export var actionText = "_qf-4";
export var container = "_qf-0";
export var leftSection = "_qf-1";
export var rightSection = "_qf-2";
export var settingsButton = "_qf-6";
export var settingsIcon = "_qf-7";
export var shortcut = "_qf-5";
export var shortcutGroup = "_qf-3";